// Module
var code = "<div class=\"js-separator {{.additionalClass}}\" {{#.isVertical}}isVertical{{/}} style=\"{{>visibility}}\"></div>";
// Exports
export default code;